import { schedulerProxy } from 'api/scheduler';

export class CustomIdentityRequestWrapper {

  grant;

  user;

  integrationId;

  constructor(user, authUrl, intId) {
    this.user = user;
    this.authUrl = authUrl;
    this.integrationId = intId;
  }

  async request(args) {
    let payload = args.body;
    if (payload) {
      const { scheduler } = payload || {};
      const { email_template } = scheduler || {};

      // Always force the editor to save false for showing nylas branding. Likely we will never
      // want that to be true.
      payload = {
        ...payload,
        scheduler: {
          ...scheduler,
          email_template: {
            ...email_template,
            show_nylas_branding: false,
          },
        },
      };
    }

    try {
      const body = JSON.stringify({
        payload,
        path: args.path,
        integration_id: this.integrationId,
        method: args.method,
      });
      const response = await schedulerProxy(body);
      // Check if the response is not okay (e.g., 404, 500)
      if (!response.ok) {
        /* eslint-disable-next-line no-console */
        console.error(`Error: ${response.status} ${response.statusText}`);
        return { error: `Error: ${response.status} ${response.statusText}` };
      }

      // Parse the response
      const { data } = response;
      return [data, null];
    } catch (error) {
      /* eslint-disable-next-line no-console */
      console.error('Fetch error:', error);
      return { error: 'Error' };
    }
  }

  /**
   * This method returns the current user's information.
   */
  async currentUser() {
    return {
      id: this.user.sub,
      email: this.user.email,
      name: this.user.name,
      provider: this.user.provider,
    };
  }

  /**
   * This method sets the default authentication arguments to use when authenticating the user.
   */
  async setDefaultAuthArgs(authArgs) {
    // Set the default authentication arguments
    return authArgs;
  };

  /**
   * This method returns the URL to redirect the user to for authentication.
   */
  async authenticationUrl() {
    return this.authUrl;
  }
}
